import { Box, Typography } from '@mui/material';
import { keyframes } from '@emotion/react';

const fadeInAnimation = keyframes`
  from {opacity: 0}
  to {opacity: 1}
`;

export const NoResults = () => {
  return (
    <Box sx={{ py: 2, my: 2, animation: `${fadeInAnimation} 1s` }}>
      <Typography variant="body1" sx={{ color: 'primary.main', fontWeight: '600' }}>
        Sorry, we couldn’t find any results for your selected status
      </Typography>
    </Box>
  );
};
